import { render, staticRenderFns } from "./UpdateBonusPointSettings.vue?vue&type=template&id=78334444&scoped=true&"
import script from "./UpdateBonusPointSettings.vue?vue&type=script&lang=js&"
export * from "./UpdateBonusPointSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78334444",
  null
  
)

export default component.exports